import React from "react";
import { useFundsController } from "./useFundsController";
import { FundsHeader } from "./components/FundsHeader";
import { FundsCard } from "./components/FundsCard";
import { FundsModals } from "./components/FundsModals";

export const Funds = () => {
  const controller = useFundsController();

  return (
    <div className="w-full">
      <FundsHeader onAddFund={() => controller.openModal("add")} />

      <FundsCard
        searchQuery={controller.searchQuery}
        setSearchQuery={controller.setSearchQuery}
        isLoading={controller.isLoading}
        filteredFunds={controller.filteredFunds}
        onEditFund={(fund) => controller.openModal("edit", fund)}
      />

      <FundsModals
        isAddFormOpen={controller.isAddFormOpen}
        isEditFormOpen={controller.isEditFormOpen}
        isDeleteDialogOpen={controller.isDeleteDialogOpen}
        selectedFund={controller.selectedFund}
        closeModal={controller.closeModal}
        handleFundForm={controller.handleFundForm}
        handleDeleteFund={controller.handleDeleteFund}
      />
    </div>
  );
};
